import { useSeo } from "../../hooks/useSeo";
import { FAQ } from "../../mocks/mockContent";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Gallery from "./components/Gallery";
import Columns from "./components/Columns";
import Faq from "./components/Faq";
import Cta from "./components/Cta";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function HomePage() {
  useSeo({
    title: "瓜田日报 - 娱乐吃瓜资讯门户，明星动态·影视综艺·网络热梗",
    description:
      "瓜田日报是一站式吃瓜资讯门户，每日聚合明星动态、影视综艺、网络热梗与热搜解读，图文并茂、观点正向，陪你健康吃瓜、理性围观。",
    path: "/",
    type: "website",
    ld: faqLd,
  });

  return (
    <>
      <Hero />
      <Feed />
      <Gallery />
      <Columns />
      <Faq />
      <Cta />
    </>
  );
}